var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2834.65 2947.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #77787b;\n      }\n\n      .cls-2 {\n        fill: #9d9fa2;\n      }\n\n      .cls-3 {\n        stroke-width: 5px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-7 {\n        stroke: #58595b;\n      }\n\n      .cls-9 {\n        fill: #8a8c8e;\n      }\n\n      .cls-10 {\n        fill: #939598;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: 20px;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-16 {\n        fill: #6d6e71;\n      }\n\n      .cls-5 {\n        stroke-width: 15px;\n      }\n\n      .cls-6 {\n        stroke: #292829;\n      }\n\n      .cls-7 {\n        stroke-width: 10px;\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-18 {\n        fill: #808285;\n      }\n\n      .cls-19 {\n        opacity: .2;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-21 {\n        fill: #e6e7e8;\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-23 {\n        fill: #bcbec0;\n      }\n\n      .cls-24 {\n        fill: #f1f1f2;\n      }\n\n      .cls-25 {\n        opacity: .25;\n      }\n\n      .cls-26 {\n        fill: #58595b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 112.98,
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 112.98,
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 112.98,
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 112.98,
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 112.98,
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 687.35,
    y: 131.31,
    width: 1459.95,
    height: 2036.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 561.81,
    width: 1451.1,
    height: 1451.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 621.74,
    y: 316.95,
    width: 1595.55,
    height: 1595.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 945.99,
    y: 2161.77,
    width: 943.9,
    height: 112.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 945.99,
    y: 2161.77,
    width: 943.9,
    height: 112.86
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 709.36,
    y: 2271.32,
    width: 1417.16,
    height: 635.31,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 709.36,
    y: 2271.32,
    width: 1417.16,
    height: 635.31,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1863.48,2761.45c95.25,0,172.47-77.22,172.47-172.47s-77.22-172.47-172.47-172.47-172.47,77.22-172.47,172.47,77.22,172.47,172.47,172.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1863.48,
    cy: 2588.98,
    r: 172.47,
    transform: "translate(-51.89 38.15) rotate(-1.16)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 808.09,
    y: 2379.53,
    width: 418.89,
    height: 418.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 808.09,
    y: 2379.53,
    width: 418.89,
    height: 418.89
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1636.25,2538.85c0-16.46-12.49-29.8-27.9-29.8s-27.89,13.34-27.89,29.8c0,12.04,6.69,22.42,16.19,27.07-1.41,1.18-11.13,6.26-13.81,7.85-2.72,1.62-11.33,5.79-8.91,8.38,.33,.35,18.61,.08,18.61,.08l.13,4.38s-.33,20.97-1.45,25.12c-1.12,4.15-2.49,9.58-5.06,14.22-2.57,4.64-12.12,18.21-13.98,20.62-1.86,2.4-10.86,14.11-11.45,14.96-.59,.86-1.19,3.17-.5,4.77,.56,1.28,1.92,2.46,3.61,4.31,2.11,2.31,7.7,8.52,7.7,8.52l-6.47,1.29s-5.23,1.09-5.23,3.6,5.7,2.69,5.7,2.69h85.77s5.7-.18,5.7-2.69-5.5-3.6-5.5-3.6l-6.47-1.29s6.38-6.03,8.56-8.52c1.66-1.89,2.49-3.03,3.05-4.31,.69-1.59,.09-3.91-.5-4.77-.59-.86-9.62-12.56-11.48-14.96-1.86-2.4-11.42-15.98-13.98-20.62-2.57-4.64-3.93-10.06-5.06-14.22-1.12-4.16-1.45-25.12-1.45-25.12l.13-4.38s18.28,.27,18.61-.08c2.42-2.58-6.19-6.75-8.91-8.37-2.68-1.59-12.4-6.68-13.85-7.88,9.43-4.68,16.08-15.04,16.08-27.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1636.25,2538.85c0-16.46-12.49-29.8-27.9-29.8s-27.89,13.34-27.89,29.8c0,12.04,6.69,22.42,16.19,27.07-1.41,1.18-11.13,6.26-13.81,7.85-2.72,1.62-11.33,5.79-8.91,8.38,.33,.35,18.61,.08,18.61,.08l.13,4.38s-.33,20.97-1.45,25.12c-1.12,4.15-2.49,9.58-5.06,14.22-2.57,4.64-12.12,18.21-13.98,20.62-1.86,2.4-10.86,14.11-11.45,14.96-.59,.86-1.19,3.17-.5,4.77,.56,1.28,1.92,2.46,3.61,4.31,2.11,2.31,7.7,8.52,7.7,8.52l-6.47,1.29s-5.23,1.09-5.23,3.6,5.7,2.69,5.7,2.69h85.77s5.7-.18,5.7-2.69-5.5-3.6-5.5-3.6l-6.47-1.29s6.38-6.03,8.56-8.52c1.66-1.89,2.49-3.03,3.05-4.31,.69-1.59,.09-3.91-.5-4.77-.59-.86-9.62-12.56-11.48-14.96-1.86-2.4-11.42-15.98-13.98-20.62-2.57-4.64-3.93-10.06-5.06-14.22-1.12-4.16-1.45-25.12-1.45-25.12l.13-4.38s18.28,.27,18.61-.08c2.42-2.58-6.19-6.75-8.91-8.37-2.68-1.59-12.4-6.68-13.85-7.88,9.43-4.68,16.08-15.04,16.08-27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M812.98,2384.97s18.02,153.12,18.02,204.17-18.02,204.17-18.02,204.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1221.6,2384.97s-18.02,153.12-18.02,204.17,18.02,204.17,18.02,204.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "812.98 2384.97 831 2587.86 1203.58 2587.86 1221.6 2384.97 812.98 2384.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1731.06,2456.72c-18.43,18.43-17.03,20.25-17.03,20.25l261.59,261.59s1.73,1.73,20.37-16.91c18.64-18.64,16.91-20.37,16.91-20.37l-261.59-261.59s-1.82-1.4-20.25,17.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1731.06,2456.72c-18.43,18.43-17.03,20.25-17.03,20.25l261.59,261.59s1.73,1.73,20.37-16.91c18.64-18.64,16.91-20.37,16.91-20.37l-261.59-261.59s-1.82-1.4-20.25,17.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1729.68,2500.4s137.07,166.93,165.22,195.07c28.14,28.14,59.93,30.08,59.93,30.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "951 2166.8 1070.99 2234.44 1884.55 2234.44 1884.55 2166.8 951 2166.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 706.35,
    y: 148.31,
    width: 1421.95,
    height: 2008.49,
    rx: 90,
    ry: 90
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 706.35,
    y: 148.31,
    width: 1421.95,
    height: 2008.49,
    rx: 90,
    ry: 90
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 706.35,
    y: 148.31,
    width: 1421.95,
    height: 2008.49,
    rx: 90,
    ry: 90
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "2000.71 158.47 716.92 1444.03 716.92 1149.01 1706.4 158.48 2000.71 158.47"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "2118.27 502.63 716.51 1905.43 716.86 1730.3 2118.27 328.26 2118.27 502.63"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine2);
export default __webpack_public_path__ + "static/media/machine2.4406358b074efeb7f3160b0d151cd539.svg";
export { ForwardRef as ReactComponent };